<template>
	<div class="order-header">
		
		
		<div  class="order_box">
			<div class="order-title" >{{$t('other.a556')}} {{$t('other.a964')}}{{total}}{{$t('other.a707')}}</div>
			<el-tabs v-model="this.$route.path"  @tab-click="handleClick">
			   <el-tab-pane 
			   v-for="item in tabs"
			   :key="item.name"
			   :label="item.label"
			   :name="item.name"
			   >
			   </el-tab-pane>
			   
			</el-tabs>	
			
		</div>
		<div>
			<keep-alive>
				   <router-view></router-view>
			   </keep-alive>
			   
		</div>
		
		
	</div>
</template>

<script>
import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default{
		data(){
			return {
				shopee:true,
				tabs: [
				  { label: "shopee", name: "/mygoods/shopee",},
				  { label: "lazada", name: "/mygoods/lazada",},
				],
			}
    },
    computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userName: state => state.shopaccess.userInfo.userName,
				userPos: state => state.shopaccess.userInfo.userPos,
				goodsTotal:state => state.mygoods.goodsTotal,
				successtotal:state => state.mygoods.successtotal,
				errorList:state => state.mygoods.errorList,
				succesList:state => state.mygoods.succesList,
				curCodeList:state => state.mygoods.curCodeList,
				lazadaitems:state => state.mygoods.lazadaitems,
				lazadaCount:state => state.mygoods.lazadaCount,
				cateGoryListCopy:state => state.mygoods.cateGoryListCopy,
				already:state => state.mygoods.already,
				
			}),
			
			total(){
				if(this.shopee){
					return this.goodsTotal
				}else{
					return this.lazadaCount
				}
			}
		},  
		created(){
			this.init()

		},
		
		methods: {
			init(){
				this.shopee=this.$route.path == '/mygoods/shopee' ?  true : false

			},
			
			handleClick(tab, event,name) {
			    this.shopee=tab.name == '/mygoods/shopee' ?  true : false
			  this.$router.replace(tab.name);
			  this.activeName = tab.name;
			  console.log(this.activeName)
			  console.log(this.$route.path)
			},
		}
		
	}
</script>

<style>
	
	/* .order-header{
		flex: 1;
		margin: 60px 0 0 225px;
	} */

	.order-header .order-title{
		font-size: 18px;
		margin-bottom: 10px;
	}
	.order-header .order_box{
		
		position: fixed;
		top:50px;
		left: 205px;
		z-index: 4;
		width: 100%;
		padding: 10px 10px;
		background-color: #fff;

	
	}

	.order-header .el-tabs__item{
		font-size: 28px!important;
	}

</style>
